
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetobelgaumcab() {



    const cardData =
    {
        keyword: ' Pune to Belgaum Cab',
        heading: 'Prince Cabs: Pune to Belgaum Cab',
        headingDescription: 'Prince Cabs offers dependable Pune to Belgaum Cab services, perfect for family trips, business travel, student journeys, and outstation tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable journey on the Pune–Belgaum route. With professional chauffeurs, flexible schedules, and on-time pickups, we make your interstate travel smooth and hassle-free. Experience comfort, affordability, and trusted service with Prince Cabs’ reliable cab service from Pune to Belgaum.',

        top: 'Top Places to Visit in Belgaum with Prince Cabs',

"topPlaces": [
  {
    "title": "Belgaum Fort",
    "description": "Belgaum Fort, built in the 13th century by the Ratta dynasty, is the city’s most historic landmark. It houses Jain temples, mosques, and the Kamal Basti, known for its Chalukyan architecture. The fort was later used by the Bahmani Sultanate, Marathas, and British, reflecting its layered history. Massive stone walls and moats surround the fort, making it a fascinating site for history buffs. Its blend of cultural and religious structures adds unique charm. Belgaum Fort is the pride of the city."
  },
  {
    "title": "Kamal Basti",
    "description": "Kamal Basti, located inside Belgaum Fort, is a 10th-century Jain temple dedicated to Neminatha. The temple is named after the lotus (Kamal) carved on its dome ceiling. It showcases fine Chalukyan-style stone carvings and pillars. The calm atmosphere makes it ideal for meditation. The temple’s heritage value attracts devotees and architecture lovers alike. Kamal Basti is a spiritual and artistic treasure within Belgaum."
  },
  {
    "title": "Gokak Falls",
    "description": "Gokak Falls, located 60 km from Belgaum, is often called the ‘Niagara of Karnataka.’ The Ghataprabha River cascades 170 feet over a sandstone cliff, creating a spectacular sight. A hanging bridge nearby offers thrilling views. Monsoon season enhances the falls’ beauty with lush greenery. The surrounding old mills and temples add historical depth. Gokak Falls is a natural wonder and a perfect weekend escape."
  },
  {
    "title": "Jamboti Hills and Falls",
    "description": "Jamboti Hills, about 25 km from Belgaum, are known for their lush forests and waterfalls. It is the origin point of the Mandovi River, which flows into Goa. Trekking trails and picnic spots attract nature lovers. The hills are especially beautiful during monsoon with misty landscapes. Jamboti also has small waterfalls and camping areas. It is a serene getaway for adventure and relaxation."
  },
  {
    "title": "Military Mahadev Temple",
    "description": "Military Mahadev Temple is a revered shrine in Belgaum, maintained by the Indian Army. Dedicated to Lord Shiva, it features a beautiful garden and fountains. The temple complex is peaceful and well-kept. It is popular among locals for morning walks and meditation. Festivals like Mahashivratri are celebrated with devotion here. Military Mahadev combines spirituality with scenic charm."
  },
  {
    "title": "Kapileshwar Temple",
    "description": "Kapileshwar Temple is one of Belgaum’s oldest shrines, dedicated to Lord Shiva. Locals call it the ‘Kashi of the South’ because visiting this temple is considered equivalent to visiting Kashi. The temple has inscriptions and architecture dating back centuries. Devotees throng here during Shivratri. Its spiritual significance makes it a must-visit for pilgrims. Kapileshwar Temple blends devotion and history."
  },
  {
    "title": "St. Mary’s Church",
    "description": "St. Mary’s Church, built during the British era, is one of the most beautiful churches in Belgaum. Its Gothic-style architecture, stained glass windows, and tall spires are striking. The church is active with regular masses and events. Its serene interior offers a peaceful retreat for visitors. The colonial charm adds to Belgaum’s cultural diversity. St. Mary’s Church is a spiritual and architectural landmark."
  },
  {
    "title": "Kittur Fort and Palace",
    "description": "Kittur Fort, located 45 km from Belgaum, is historically significant for the bravery of Rani Chennamma. The fort houses a ruined palace, temples, and a museum displaying artifacts. It narrates stories of resistance against the British. The fort is surrounded by scenic landscapes, making it both historic and picturesque. Kittur is a symbol of valor and patriotism. It is a key heritage site near Belgaum."
  },
  {
    "title": "Rakaskop Reservoir",
    "description": "Rakaskop Reservoir, about 18 km from Belgaum, is a popular picnic spot surrounded by hills. It supplies water to the city and is ideal for nature walks. The calm waters and greenery create a refreshing environment. Visitors enjoy boating and photography here. During monsoon, the reservoir looks especially beautiful. It is a peaceful retreat close to the city."
  },
  {
    "title": "Safa Masjid",
    "description": "Safa Masjid, built by Adil Shah in the 16th century, is one of the oldest mosques in Belgaum. It is known for its large hall with stone pillars and arches. The mosque has a simple yet striking Indo-Islamic design. Its location inside Belgaum Fort adds to its heritage value. Devotees and tourists visit to admire its spiritual ambiance. Safa Masjid reflects the city’s religious harmony."
  }
],

    "services": [
    {
      "name": "Pune to Belgaum Cab Service",
      "description": "Reliable and comfortable cab service from Pune to Belgaum, perfect for business trips, family visits, or leisurely travel. Choose from a range of vehicles to suit your preferences and budget."
    },
    {
      "name": "Pune to Belgaum Taxi",
      "description": "Affordable taxi options for the Pune to Belgaum route with professional drivers, timely pickups, and safe travel experience. Ideal for one-way and round-trip bookings."
    },
    {
      "name": "Pune to Belgaum Innova Crysta",
      "description": "Travel in style and spacious comfort with Innova Crysta taxi from Pune to Belgaum. Perfect for families and groups looking for premium travel experience on long-distance trips."
    },
    {
      "name": "Pune to Belgaum Innova Taxi Fare",
      "description": "Transparent and competitive Innova taxi fares for Pune to Belgaum journeys, ensuring value for money without compromising on comfort and service quality."
    },
    {
      "name": "Sedan Taxi in Pune",
      "description": "Sedan taxi services available in Pune offering comfortable rides for local travel or outstation trips, including Sedans like Dzire and Etios."
    },
    {
      "name": "Sedan Cab Service",
      "description": "Choose from a wide variety of sedan cabs in Pune, ideal for solo travelers, couples, and small families seeking a comfortable and economical ride."
    },
    {
      "name": "Pune to Hubli Cab",
      "description": "Efficient cab service from Pune to Hubli with various vehicle options including Innova, Dzire, and Etios to match your travel needs."
    },
    {
      "name": "Pune to Bijapur Cab",
      "description": "Affordable and reliable taxi services for the Pune to Bijapur route, offering comfortable vehicles and professional drivers."
    },
    {
      "name": "Pune to Belgaum Dzire Taxi",
      "description": "Book Dzire cabs from Pune to Belgaum for a budget-friendly yet comfortable travel experience, perfect for smaller groups and families."
    },
    {
      "name": "Pune to Belgaum Etios Cab",
      "description": "Etios cab service for Pune to Belgaum providing economical rides with a focus on safety and punctuality."
    },
    {
      "name": "Pune to Belgaum Affordable Taxi",
      "description": "Affordable taxi options from Pune to Belgaum with well-maintained vehicles, ensuring a hassle-free travel experience for all budgets."
    },
    {
      "name": "Pune to Belgaum Round Trip Cab",
      "description": "Convenient round trip cab service from Pune to Belgaum allowing flexible schedules and comfortable travel arrangements."
    },
    {
      "name": "Luxury Pune to Belgaum Innova",
      "description": "Experience luxury travel from Pune to Belgaum with premium Innova cabs featuring plush interiors, ample space, and courteous drivers."
    }
  ],
  "tableData": [
    ["Pune to Belgaum Cab Service", "Pune to Belgaum Taxi"],
    ["Pune to Belgaum Innova Crysta", "Pune to Belgaum Innova Taxi Fare"],
    ["Sedan Taxi in Pune", "Sedan Cab Service"],
    ["Pune to Hubli Cab", "Pune to Bijapur Cab"],
    ["Pune to Belgaum Dzire Taxi", "Pune to Belgaum Etios Cab"],
    ["Pune to Belgaum Affordable Taxi", "Pune to Belgaum Round Trip Cab"],
    ["Luxury Pune to Belgaum Innova"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Belgaum Cab Service",
        "WhyChoosedescription": "Prince Cabs provides trustworthy and comfortable cab services from Pune to Belgaum, ideal for business travelers, tourists, and families. Covering approximately 500 kilometers, our service ensures a safe, smooth, and hassle-free journey, allowing you to reach your destination relaxed and on time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet features sedans and SUVs like Swift Dzire and Innova, equipped with spacious seating, ample luggage space, and air conditioning to ensure maximum comfort during the long journey from Pune to Belgaum."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Route",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of the Pune to Belgaum route, ensuring safe driving, efficient navigation, and timely breaks to make your trip smooth and pleasant."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Needs",
        "WhyChoosedescription": "Prince Cabs offers customizable packages including one-way trips, round trips, and multi-day rentals. You can book easily via phone, WhatsApp, or online, with instant confirmation and flexible cancellation policies."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing for Pune to Belgaum cab service is clear and competitive, covering fuel, tolls, driver allowances, and taxes. Multiple secure payment methods are accepted including UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
        "WhyChoosedescription": "Each vehicle is thoroughly cleaned and sanitized before every trip. Regular maintenance ensures mechanical reliability, and safety features such as seat belts and airbags guarantee passenger protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our dedicated customer care team is available round the clock to assist with bookings, itinerary changes, and any travel-related queries, making your Pune to Belgaum cab experience smooth and worry-free."
    }
]
































    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services from Pune to Belgaum?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Pune to Belgaum, ideal for business, leisure, and family trips.',
    },
    {
        question: 'What types of vehicles are available for Pune to Belgaum trips?',
        answer: 'We provide a range of vehicles including Swift Dzire, Innova, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Pune to Belgaum take by cab?',
        answer: 'The journey usually takes around 6 to 7 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Belgaum?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort throughout the trip.',
    },
    {
        question: 'What are the approximate fares for Pune to Belgaum cab service?',
        answer: 'Fares vary based on vehicle type, distance, and duration. Please contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Pune to Belgaum?',
        answer: 'You can easily book through our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Manoj Kulkarni",
        position: "Frequent Traveler",
        text: "I frequently travel from Pune to Belgaum with Prince Cabs. The service is punctual, and the vehicles are comfortable and clean.",
        image: "/img/testimonial/testimonial-thumb-belgaum-1.png",
    },
    {
        name: "Ms. Anjali Patil",
        position: "Family Traveler",
        text: "Our Pune to Belgaum trip was smooth and hassle-free thanks to Prince Cabs. The driver was courteous and professional.",
        image: "/img/testimonial/testimonial-thumb-belgaum-2.png",
    },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Belgaum Cab",
  "description": "Reliable cab services from Pune to Belgaum including Innova Crysta, Dzire, Etios, and Sedan taxis. Affordable pricing with options for round trip and luxury rides.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Belgaum Cab Service",
    "Pune to Belgaum Taxi",
    "Pune to Belgaum Innova Crysta",
    "Pune to Belgaum Innova Taxi Fare",
    "Sedan Taxi in Pune",
    "Sedan Cab Service",
    "Pune to Hubli Cab",
    "Pune to Bijapur Cab",
    "Pune to Belgaum Dzire Taxi",
    "Pune to Belgaum Etios Cab",
    "Pune to Belgaum Affordable Taxi",
    "Pune to Belgaum Round Trip Cab",
    "Luxury Pune to Belgaum Innova"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Belgaum Cab | Innova, Dzire, Etios Taxi Service</title>
  <meta
    name="description"
    content="Reliable cab services from Pune to Belgaum including Innova Crysta, Dzire, Etios, and Sedan taxis. Affordable pricing with round trip and luxury ride options."
  />
  <meta
    name="keywords"
    content="Pune to Belgaum Cab Service, Pune to Belgaum Taxi, Pune to Belgaum Innova Crysta, Pune to Belgaum Innova Taxi Fare, Sedan Taxi in Pune, Sedan Cab Service, Pune to Hubli Cab, Pune to Bijapur Cab, Pune to Belgaum Dzire Taxi, Pune to Belgaum Etios Cab, Pune to Belgaum Affordable Taxi, Pune to Belgaum Round Trip Cab, Luxury Pune to Belgaum Innova"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobelgaumcab ;